import { Component, OnInit } from '@angular/core';
import { UserService } from '../../services/user/user.service';
import { AppearanceService } from '../../services/appearance/appearance.service';
import { ModalController } from '@ionic/angular';
import { ClientService } from 'src/app/services/client/client.service';
import { JobService } from 'src/app/services/job/job.service';
import { ConditionReportModel } from 'src/app/models/condition-report.model';



@Component({
  selector: 'modal-add-asset',
  templateUrl: './modal-add-asset-condition.component.html',
  styleUrls: ['./modal-add-asset-condition.component.scss'],
})
export class ModalAddAssetConditionComponent implements OnInit {


  newCondition: ConditionReportModel = null;
  assetNameError: boolean = false;
  isStreetLight: boolean = false;

  
  constructor(public appearanceService: AppearanceService, public jobService: JobService,
   public userService: UserService, public modalController: ModalController, 
   public clientService: ClientService) {

  }


  ngOnInit() 
  {
    this.newCondition = new ConditionReportModel();
  }


  ionViewWillEnter()
  {
    this.assetNameError = false;

    this.newCondition = new ConditionReportModel();

    this.newCondition.assetName     = "";
    this.newCondition.summary       = "Good";
    this.newCondition.approxAge     = "15 - 25";
    this.newCondition.columnType    = null;
    this.newCondition.headType      = null;
    this.newCondition.notes         = "";

    if (this.isStreetLight)
    {
      this.newCondition.columnType  = "Steel";
      this.newCondition.headType    = "Beta Style";
    }
  }


  ionViewDidEnter()
  {

  }


  ionViewWillLeave()
  {

  }


  ionViewDidLeave()
  {
    
  }


  closeModal(returnData = null)
  {
    this.modalController.dismiss(returnData, null, 'NameAssetModal');
  }


  save()
  {
    this.assetNameError = false;

    if (this.newCondition.assetName == "")
    {
      this.assetNameError = true;
      return;
    }

    var returnData = { assetDetails: this.newCondition };
    this.modalController.dismiss(returnData, null, 'NameAssetModal');
  }
}
